export default "__VITE_ASSET__NVFCcWez__"